// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"eb6019fa","93":"9a5b7656","220":"7f503166","427":"70288ba0","553":"0f5b7f68","607":"0d92b4f8"}[chunkId] + ".chunk.css";
};